import React, { useId } from 'react';
import PropTypes from 'prop-types';
import './DangerZone.css';

/**
 * Irreversible actions, separated from the form they belong to.
 *
 * On /Update these two sat directly beneath Save at the same size and weight,
 * and their labels — "Delete" and "Delete recent upload" — did not convey that
 * one removes a single version and the other removes the entire listing. The
 * per-row description is the fix; the separation from Save is the safeguard.
 */
export default function DangerZone({ actions }) {
  const headingId = useId();

  if (!actions || actions.length === 0) return null;

  return (
    <section className="itcDangerZone" aria-labelledby={headingId}>
      <h2 className="itcDangerZoneTitle" id={headingId}>
        Danger zone
      </h2>

      <ul className="itcDangerZoneList">
        {actions.map((action) => (
          <li className="itcDangerZoneRow" key={action.id}>
            <div className="itcDangerZoneMeta">
              <p className="itcDangerZoneName">{action.title}</p>
              <p className="itcDangerZoneDesc">{action.description}</p>
            </div>

            <button
              type="button"
              className="itcDangerZoneButton"
              onClick={action.onSelect}
            >
              {action.buttonLabel}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}

DangerZone.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      buttonLabel: PropTypes.string.isRequired,
      onSelect: PropTypes.func.isRequired,
    })
  ),
};
